import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

interface AlertBannerContextProps {
  cookieAlertBanner: boolean;
  setCookieAlertBanner: (value: boolean) => void;
}

export const AlertBannerContext = createContext<
  AlertBannerContextProps | undefined
>(undefined);

export const useAlertBanner = () => {
  const context = useContext(AlertBannerContext);
  if (!context) {
    throw new Error('useAlertBanner must be used within a AlertBannerProvider');
  }
  return context;
};

export const AlertBannerProvider = ({ children }: { children: ReactNode }) => {
  const [cookieAlertBanner, setCookieAlertBanner] = useState(true);

  return (
    <AlertBannerContext.Provider
      value={{ cookieAlertBanner, setCookieAlertBanner }}
    >
      {children}
    </AlertBannerContext.Provider>
  );
};
